module.exports = __webpack_public_path__ + "static/img/01.69ec347.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/tell_tex/01.jpg
// module id = 451
// module chunks = 1